module.exports = __webpack_public_path__ + "public/adminIcons/reservationicon.svg?b66c14f7";